import { Box } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import RecalculateDialog from "./RecalculateDialog";
import UpdateStatusDialog from "./UpdateStatusDialog";

const ActionButtons = ({
  filters,
  setBudgetInfo,
  campaignId,
  excludedIds,
  allSeenIds,
  fetchApprovedApplications,
  resetSelection,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <SecuredComponent permission={permissions.canPreviewApprovedScholarshipApplicationsBudget}>
        <RecalculateDialog
          filters={filters}
          setBudgetInfo={setBudgetInfo}
          excludedIds={excludedIds}
        />
      </SecuredComponent>
      <SecuredComponent permission={permissions.canUpdateApprovedScholarshipApplicationsStatus}>
        <UpdateStatusDialog
          campaignId={campaignId}
          excludedIds={excludedIds}
          allSeenIds={allSeenIds}
          fetchApprovedApplications={fetchApprovedApplications}
          resetSelection={resetSelection}
        />
      </SecuredComponent>
    </Box>
  );
};

export default ActionButtons;
